import Service from "../service";
// import AuthService from "../AuthServ

const Deathreason = {
    getDeathreason() {
        return Service.get('/deathreason')
    }
};


export default Deathreason;
